import axios from 'axios'

export default {
    name: "",
    id: "",
    authenticationMethod: "",
    registered: false,
    email: "",
    avatarURL: "",
    loginEnabled: false,

    identified() {
        return this.id !== ""
    },

    apply(profile) {
        this.id = profile.user_id
        this.name = profile.name
        this.authenticationMethod = profile.authentication_method
        this.registered = !!profile.registered
        this.email = profile.email || ""
        this.avatarURL = profile.avatar_url || ""
    },

    clear() {
        this.id = ""
        this.name = ""
        this.authenticationMethod = ""
        this.registered = false
        this.email = ""
        this.avatarURL = ""
    },

    async loadAuthConfig() {
        const response = await axios.get("auth/config", {timeout: 10000})
        this.loginEnabled = response.data.enabled
    },

    async startLogin(returnPath) {
        const response = await axios.post("auth/google", {return_path: returnPath}, {timeout: 10000})
        window.dispatchEvent(new Event('deminworks:sign-in-start'))
        window.location.assign(response.data.authorization_url)
    },

    async restore() {
        try {
            const response = await axios.get("me", {timeout: 10000})
            this.apply(response.data)
            return true
        } catch (error) {
            if (!error.response || error.response.status !== 401) throw error
            this.clear()
            return false
        }
    },

    async authenticate() {
        const proposedName = this.name
        if (await this.restore()) return
        if (!proposedName || !proposedName.trim()) throw new Error("A guest name is required")

        const response = await axios.post("register", {name: proposedName}, {timeout: 10000})
        this.apply(response.data)
    },

    async update(name) {
        await axios.put("me", {name}, {timeout: 10000})
        this.name = name
    },

    async logout() {
        await axios.post("logout", {}, {timeout: 10000})
        this.clear()
    },
}
